import { useQuery } from "@tanstack/react-query";
import { TaskKeys } from "web_myplann/Api/Tasks/TaskKeys";
import { getTaskIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useTaskQuery = (taskId: number) => {
	return useQuery({
		queryKey: TaskKeys.detail(taskId),
		queryFn: processResponse(() => getTaskIdV2(taskId)),
		enabled: taskId !== 0,
	});
};
